import Field from "./Field";
import { lei, packTotals, shortName } from "@/lib/pricing";

export default function PackagePanel({ pack, cat, onChange }) {
  const byId = Object.fromEntries(cat.products.map((p) => [p.id, p]));
  const t = packTotals(pack, cat);
  const { markup, vat } = cat;
  const set = (key) => (value) => onChange({ ...pack, [key]: value });
  return (
    <div className="st-panel-body" data-testid="package-panel">
      <Field label="Nume pachet" value={pack.name} onChange={set("name")} testId="package-name-input" />
      <Field label="Descriere scurtă" value={pack.tagline} onChange={set("tagline")} testId="package-tagline-input" />
      <Field
        label="Discount %"
        value={String(pack.discount)}
        onChange={(v) => set("discount")(Math.min(90, Math.max(0, parseInt(v, 10) || 0)))}
        testId="package-discount-input"
        big
      />
      <div className="st-summary" data-testid="package-summary">
        <div><span>Valoare listă (TVA inclus)</span><b>{lei(t.list)}</b></div>
        <div><span>Preț pachet (-{pack.discount}%) cu TVA {vat}%</span><b>{lei(t.price)}</b></div>
        {t.gifts > 0 && <div><span>Cadouri</span><b>{lei(t.gifts)}</b></div>}
        <div><span>{t.treatments} tratamente × {cat.service_price} lei</span><b>{lei(t.treatRevenue)}</b></div>
        <div><span>Revânzare produse mici (+{markup}%)</span><b>{lei(t.resale)}</b></div>
        <div><span>Profit salon (cu TVA)</span><b>{lei(t.profit)}</b></div>
      </div>
      <div className="st-section-title">Conținut</div>
      <ul className="st-items">
        {pack.items.map((it) => (
          <li key={it.id}>{it.qty}× {shortName(byId[it.id].name)} {byId[it.id].size}</li>
        ))}
        {(pack.gifts || []).map((it) => (
          <li key={`g${it.id}`} className="is-gift">{it.qty}× {shortName(byId[it.id].name)} {byId[it.id].size} · cadou</li>
        ))}
      </ul>
    </div>
  );
}
